'use client';

import { useEffect, useState } from 'react';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import mentorsData from '@/data/mentors.json';

export default function MentorsSection() {
  const [mentors, setMentors] = useState([]);
  const pathname = usePathname();

  useEffect(() => {
    // Extract slug from pathname
    const slug = pathname.split('/').filter(Boolean).pop();
    
    // Find the program that matches the slug
    const program = mentorsData.find(p => 
      p.slug === slug || 
      p.slug === `workshops/${slug}` || 
      pathname.includes(p.slug)
    );
    
    if (program) {
      // Extract mentors from the program data
      const mentorsList = extractMentors(program);
      setMentors(mentorsList);
    }
  }, [pathname]);

  // Function to extract mentor objects from program data
  const extractMentors = (program) => {
    const mentorsList = [];
    
    // Loop through potential mentor entries (from 1 to 11)
    for (let i = 1; i <= 11; i++) {
      const nameKey = `mentor${i}name`;
      const imageKey = `mentor${i}image`;
      const postKey = `mentor${i}post`;
      
      // Only add if all three properties exist
      if (program[nameKey] && program[imageKey] && program[postKey]) {
        mentorsList.push({
          name: program[nameKey],
          image: program[imageKey],
          position: program[postKey]
        });
      }
    }
    
    return mentorsList;
  };

  // Don't render the section if no mentors found
  if (mentors.length === 0) return null;

  return (
    <section className="w-full py-10 bg-white">
      <div className="">
        <h2 className="text-[32px] font-medium text-[#002726] mb-8">
          Meet Your Mentors
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-5">
          {mentors.map((mentor, index) => (
            <div key={index} className="flex items-center">
              {/* Mentor image with border */}
              <div className="relative w-[42px] h-[42px] rounded-md border border-gray-200 overflow-hidden flex-shrink-0">
                <Image
                  src={mentor.image}
                  alt={mentor.name}
                  fill
                  className="object-cover"
                />
              </div>
              
              {/* Mentor name and position */}
              <div className="ml-4">
                <h3 className="text-sm font-medium text-[#002726]">
                  {mentor.name}
                </h3>
                <p className="text-[#002726] text-sm font-normal">
                  {mentor.position}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
